const PALETTE = [
  'bg-blush-200 text-blush-500',
  'bg-sky-baby text-sky-800',
  'bg-mint-baby text-emerald-800',
  'bg-lemon-baby text-amber-800',
  'bg-lilac-baby text-indigo-800',
]

// Deterministic pastel avatar so each family member keeps the same colour.
export default function Avatar({ initials, size = 'md' }) {
  const seed = [...(initials || '?')].reduce((total, char) => total + char.charCodeAt(0), 0)
  const color = PALETTE[seed % PALETTE.length]
  const sizing = size === 'sm' ? 'h-8 w-8 text-xs' : size === 'lg' ? 'h-14 w-14 text-lg' : 'h-10 w-10 text-sm'

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full border-2 border-white font-display font-bold ${color} ${sizing}`}
      aria-hidden="true"
    >
      {initials || '?'}
    </span>
  )
}
